import Swiper from 'swiper/swiper-bundle.min'

let Gallery = {
    init: function () {
        this.gallery()
    },
    gallery: function () {
        let thumbGallery = new Swiper(".mySwiper", {
            loop: false,
            spaceBetween: 5,
            slidesPerView: 8,
            freeMode: false,
            watchSlidesProgress: true,
        });
        let gallery = new Swiper(".mySwiper2", {
            loop: true,
            spaceBetween: 0,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumbGallery,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
        });
    }
}

Gallery.init()
